<template>
    <div class="digitalIDWrap">
        <div class="digitalIDWrap-tips">
            必填进度&nbsp;<el-progress :percentage="percentage"></el-progress>
            应监管要求，该类目商品需向中国物品编码中心申请产品数字身份证，填写相关信息后可对用户展示产品数字身份证。
        </div>
        <div class="digitalIDWrap-content">
            <div class="digitalIDWrap-tips2">
                <i class="el-icon-Group-21" style="color:#1b67ff;font-size: 16px;"></i>
                <span class="ml-5">根据商品条形码已自动识别并填入更多产品身份证属性信息，请检查是否完整准确</span>
            </div>
            <CategoryAttr 
                v-model="formData" 
                :initAttrData="initAttrData" 
                :initMeasureData="initMeasureData" 
                :baseItemId="baseItemId" 
                :categoryIds="categoryIds" 
                :namePrefix="namePrefix" 
                :getPrefix="getPrefix" 
                :categoryProperties="digitalIDList"
                :isShowRefresh="false"
                @refundRuleChange="handleRefundRuleChange" 
                @select-changed="handleCategoryValueChanged" 
            />
        </div>
    </div>
</template>

<script> 
import CategoryAttr from './CategoryAttr.vue';
export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        categoryIds: {
            type: Array,
            default() {
                return []
            }
        },
        value: {
            type: String,
            default: ''
        },
        initAttrData: {
            type: Object,
            default() {
                return {}
            }
        },
        initMeasureData: {
            type: Object,
            default() {
                return {}
            }
        },
        baseItemId: [Number, String],
        getPrefix: Function,
        namePrefix:{
            type: String
        },
        digitalIDList:{
            type: Array,
            default: () => []
        },
    },
    components:{ CategoryAttr },
    data() {
        return {
            rules: {},
            formData: '',
        }
    },
    computed:{
      percentage(){
        let _formData = JSON.parse(this.formData || '{}')
        let requiredNum = 0;
        let hasValueNum = 0;
        this.digitalIDList.forEach(item => {
            if(!!item.required){
                ++requiredNum;
                if(_formData[item.propertyId]){
                    ++hasValueNum;
                }
            }
        })
        return parseFloat((hasValueNum/requiredNum).toFixed(2))*100
      }
    },
    watch: {
        formData:{
            handler(val) {
                this.formData = val
                this.$emit('change', val);
            },
        }
    },
    methods: {
        method_valid(){
            return this.percentage === 100 ? '' : '请完善产品数字身份证信息'
        },
        handleRefundRuleChange(data = []){
            this.$emit('refundRuleChange', data);
        },
        handleCategoryValueChanged(data){
            this.$emit('select-changed', data)
        }
    },
}
</script>

<style lang="scss" scoped>
.digitalIDWrap-tips{
    display: flex;
    font-size: 12px;
    color: #ccc;
    align-items: center;
    margin-bottom: 10px;
}
.digitalIDWrap-content{
    padding: 20px;
    background: #F9F9FA;
}
.digitalIDWrap-tips2{
    font-size: 12px;
    display: flex;
    align-items: center;
    padding: 5px 10px 5px 10px;
    background: #ecf2fe;
    border-radius: 3px;
}
.digitalIDWrap{
    ::v-deep .el-progress{
        width: 150px;
        margin-left: 10px;
        .el-progress__text{
            font-size: 12px !important;
        }
    }
}
</style>